import { registerSW } from 'virtual:pwa-register';

/**
 * Meldet den Service Worker an, damit die App installierbar ist und offline
 * funktioniert. Eine neue Version wird angekündigt und erst nach Bestätigung
 * aktiviert, damit mitten im Kochen nichts überraschend neu lädt.
 */
export function registerServiceWorker(): void {
  if (import.meta.env.DEV) {
    return;
  }

  const updateSW = registerSW({
    onNeedRefresh() {
      const confirmed = window.confirm('Eine neue Version ist verfügbar. Jetzt neu laden?');
      if (confirmed) {
        void updateSW(true);
      }
    },
    onOfflineReady() {
      console.warn('Das Kochbuch ist jetzt offline verfügbar.');
    },
  });
}
